module.exports = __webpack_public_path__ + "static/media/t2.0247ada3.svg";